/**
 * myseInspect 模块的 Redux slice
 *
 * 当前实现为空占位：
 * - 模块内 3 个页面均使用组件本地 hooks 管理 state，不依赖全局 store
 * - 此 slice 仅为保留 store.ts 的注册行不变（src/app/store.ts 引用此默认导出）
 *
 * 如后续有跨页共享状态需求，可在此扩展。
 */
import { createSlice } from '@reduxjs/toolkit'

interface MyseInspectState {
  /** 占位字段，避免空对象被 TS 严格模式判定为 never */
  _placeholder: boolean
}

const initialState: MyseInspectState = {
  _placeholder: false
}

const myseInspectSlice = createSlice({
  name: 'myseInspect',
  initialState,
  reducers: {}
})

export default myseInspectSlice.reducer
